import React, { useEffect } from 'react'
import { useAuth } from '../../Firebase/AuthProvider'
import { Navigate, useLocation } from 'react-router-dom';
import { getSubdomain } from '../../Localization/routesLocalized';
import { useDialog } from '../../Providers/Dialog/DialogProvider';
import AdminBar from './AdminBar';

import { useLangNavigate } from '../../Localization/useLangNavigate';

export default function AdminCheck({ children }) {
    const { setDialog } = useDialog();
    const { user, loading } = useAuth();
    const navigate = useLangNavigate();
    const location = useLocation();
    const isLoginPage = Boolean(location.pathname.includes("/login"));
    const subdomain = getSubdomain();

    const redirect = async (path) => {
        setTimeout(async () => {
            navigate(path);
        }, 50);
    }

    useEffect(() => {
        if (subdomain !== 'admin') {
            return;
        }

        const checkClaims = async () => {
            if (user) {
                const tokenResult = await user.getIdTokenResult();
                const claims = tokenResult.claims;
                if (!claims?.admin && !isLoginPage) {
                    setDialog("Your account does not have permission to access this section.");
                    redirect('login');
                } else if (claims?.admin && isLoginPage) {
                    redirect('/');
                }
            }
        }

        checkClaims();
    }, [user, subdomain]);

    if (subdomain === "admin" && !user && !loading && !isLoginPage) {
        redirect('login');
    } else if (subdomain === "admin") {
        return (
            <>
                {!isLoginPage && <AdminBar />}
                {children}
            </>
        )
    }

    return (
        <>
            {children}
        </>
    )
}
